// extracted by mini-css-extract-plugin
module.exports = {"checkoutButtons":"wySzUA","expressButtonsContainer":"EJm3OC"};